/**
 * Recently Viewed products — tracks visits in localStorage and renders
 * the same product-card markup used in collections / More to Love.
 */
(function () {
  var RV_KEY = 'nookie_recently_viewed';
  var MAX = 12;

  function getList() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }

  function track() {
    var p = window.__rvCurrentProduct;
    if (!p || !p.id) return;
    var list = getList().filter(function (i) { return i.id !== p.id; });
    list.unshift(p);
    if (list.length > MAX) list = list.slice(0, MAX);
    localStorage.setItem(RV_KEY, JSON.stringify(list));
  }

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
  }

  function fallbackCard(item) {
    var card = document.createElement('product-card');
    card.className = 'product-card product-card--info-outside product-card--blends';
    if (item.handle) card.setAttribute('handle', item.handle);
    card.innerHTML =
      '<div class="product-card__figure">' +
        '<a href="' + escapeHtml(item.url) + '" class="product-card__media">' +
          (item.image
            ? '<img class="product-card__image product-card__image--primary aspect-short" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="400" height="600">'
            : '') +
        '</a>' +
      '</div>' +
      '<div class="product-card__info">' +
        '<div class="v-stack gap-1">' +
          '<a href="' + escapeHtml(item.url) + '" class="product-title text-sm">' + escapeHtml(item.title) + '</a>' +
          '<price-list class="price-list">' +
            '<sale-price class="text-sm text-subdued">' + money(item.price) + '</sale-price>' +
          '</price-list>' +
        '</div>' +
      '</div>';
    return card;
  }

  async function fetchCard(item) {
    if (!item.handle) return fallbackCard(item);
    try {
      var response = await fetch(rootPath() + 'products/' + encodeURIComponent(item.handle) + '?section_id=product-card-ajax');
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var card = doc.querySelector('product-card');
      if (!card) throw new Error('no card');
      card.removeAttribute('reveal-on-scroll');
      return card;
    } catch (error) {
      return fallbackCard(item);
    }
  }

  async function render(panel) {
    var current = window.__rvCurrentProduct;
    var currentId = current && current.id;
    var list = getList().filter(function (i) { return i.id !== currentId; });

    var empty = panel.querySelector('.rp-rv-empty');
    var carousel = panel.querySelector('.rp-rv-carousel');
    var progress = panel.querySelector('.rp-rv-progress');
    var listEl = panel.querySelector('.rp-recently-viewed-list');

    if (!list.length) {
      if (empty) empty.style.display = '';
      if (carousel) carousel.style.display = 'none';
      if (progress) progress.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (carousel) carousel.style.display = '';
    if (progress) progress.style.display = '';
    if (!listEl) return;

    listEl.replaceChildren();

    var cards = await Promise.all(list.map(fetchCard));
    cards.forEach(function (card) {
      listEl.appendChild(card);
    });

    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  function observePanel(panel) {
    if (panel.dataset.rvObserved) return;
    panel.dataset.rvObserved = '1';

    if (!panel.hidden) {
      panel.dataset.rendered = '1';
      render(panel);
    }

    var observer = new MutationObserver(function () {
      if (!panel.hidden && !panel.dataset.rendered) {
        panel.dataset.rendered = '1';
        render(panel);
      }
    });
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  }

  function observeAllPanels() {
    document.querySelectorAll('[id^="rp-recentlyviewed"]').forEach(observePanel);
  }

  /* When the visitor already has 2+ recently viewed products (excluding the
     one they're on), open the Recently Viewed tab by default. The tab bar is
     injected later by the product-recommendations AJAX load, so this is
     retried from the body MutationObserver until the buttons exist. Only
     auto-selects once so a manual tab switch is never overridden. */
  var autoSelected = false;

  function autoSelectTab() {
    if (autoSelected) return;

    var current = window.__rvCurrentProduct;
    var currentId = current && current.id;
    var count = getList().filter(function (i) { return i.id !== currentId; }).length;
    if (count < 2) {
      autoSelected = true;
      return;
    }

    var tabs = document.querySelectorAll('button[role="tab"][aria-controls^="rp-recentlyviewed"]');
    if (!tabs.length) return; /* not in the DOM yet — retry on next mutation */
    autoSelected = true;

    customElements.whenDefined('featured-collections-tabs').then(function () {
      requestAnimationFrame(function () {
        tabs.forEach(function (tab) {
          if (tab.getAttribute('aria-selected') !== 'true') tab.click();
        });
      });
    });
  }

  var watchingDom = false;

  function init() {
    track();
    observeAllPanels();
    autoSelectTab();

    if (!watchingDom) {
      watchingDom = true;
      new MutationObserver(function () {
        observeAllPanels();
        autoSelectTab();
      }).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
